export default __webpack_public_path__ + "static/media/bell-pepper-desktop.c8c51940.png";